import React,{useState} from 'react';

const CVV = ({card}) => {
    const [show,setShow] = useState(false)
  return <span style={{float:'right',zIndex:999,cursor:'pointer'}} onClick={()=>setShow(!show)}>cvv: {!show?"***":card?.cvv} {show?<i className="fa fa-eye"></i>:<i className="fa fa-eye-slash"></i>} </span>
};

export default CVV;
